import BaseApi from '@/services/api/BaseApi';

export default class ExampleApi extends BaseApi {
    protected type: string = 'examples';
}
